import * as React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import StatusContext from '../../../contexts/StatusContext'
import AITestContext from '../../../contexts/AITestContext'

import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {ScrollText} from "../scrolltext/ScrollText"

import { CancelIcon } from '../customicons/CancelIcon';
import { CheckIcon } from '../customicons/CheckIcon';
import { useState } from "react";
import './aitest.css'

  import MarkdownResponseDisplay from '../markdown/MarkdownResponseDisplay';

export const DialogModifyTest = () => {

  const [status, setStatus] = useState('')
  
  const {
    changeLanguage,
} = React.useContext(StatusContext);

const {
    showModifyTestDialog,
    setShowModifyTestDialog,
    modifyTest,
    setModifyTest,
    sendImproveText,
    getTestLanguage,
    createcollegetestmode,
    subtopics,
    setSubtopics,

} = React.useContext(AITestContext);


const handleChangeQuestion = (event) => {
  event.target.style.height = 'auto';
  event.target.style.height = `${event.target.scrollHeight}px`;
 
  // Create a new object for modifyTest
  const updatedModifyTest = {
    ...modifyTest,
    prompt: event.target.value // Update the prompt
  };
 
  setModifyTest(updatedModifyTest)
};

const handleTranslateQuestion = () => {

  let testlanguage = getTestLanguage()
  sendImproveText(`Translate this text to ${testlanguage}.Response must be ONLY text translation and in latinic alphabet.:`, modifyTest.prompt, -1)
}

const handleTranslateAnswer1 = () => {
  let testlanguage = getTestLanguage()
  sendImproveText(`Translate this text to ${testlanguage}.Response must be ONLY text translation and in latinic alphabet.:`, modifyTest.response.answer[0][0], 0)
}

const handleTranslateAnswer2 = () => {
  let testlanguage = getTestLanguage()
  sendImproveText(`Translate this text to ${testlanguage}.Response must be ONLY text translation and in latinic alphabet.:`, modifyTest.response.answer[1][0], 1)
}

const handleTranslateAnswer3 = () => {
  let testlanguage = getTestLanguage()
  sendImproveText(`Translate this text to ${testlanguage}.Response must be ONLY text translation and in latinic alphabet.:`, modifyTest.response.answer[2][0], 2)
}

const handleUpdateFormulaQuestion = () => {
  sendImproveText("Popravi samo formule koristeci markdown u sledecem tekstu. Ovaj  tekst je pitanje u testu i mora da ostane nepromenjeno. Nemoj da dajes odgovor na pitanje:", modifyTest.prompt, -1)
}

const handleUpdateFormulaAnswer1 = () => {
  sendImproveText("Propravi samo formule koristeci markdown u sledecem tekstu. Originalni tekst mora da ostane nepromenjen.  Ovaj text je deo testa i ako je text netacan ne ispravljaj ga:", modifyTest.response.answer[0][0], 0)
  //sendImproveText("Popravi ovu formulu koristeci markdown (A je matrica). Samo popravi formulu i nemoj da dodajes nikakav text:", modifyTest.response.answer[0][0], 0)
}

const handleUpdateFormulaAnswer2 = () => {
  sendImproveText("Propravi samo formule koristeci markdown u sledecem tekstu. Originalni tekst mora da ostane nepromenjen. Ovaj text je deo testa i ako je text netacan ne ispravljaj ga:", modifyTest.response.answer[1][0], 1)
  //sendImproveText("Popravi ovu formulu koristeci markdown (A je matrica). Samo popravi formulu i nemoj da dodajes nikakav text:", modifyTest.response.answer[1][0], 1)
}

const handleUpdateFormulaAnswer3 = () => {
  sendImproveText("Propravi samo formule koristeci markdown u sledecem tekstu. Originalni tekst mora da ostane nepromenjen. Ovaj text je deo testa i ako je text netacan ne ispravljaj ga:", modifyTest.response.answer[2][0], 2)
  //sendImproveText("Popravi ovu formulu koristeci markdown (A je matrica) Samo popravi formulu i nemoj da dodajes nikakav text:", modifyTest.response.answer[2][0], 2)
}


const handleChangeAnswer1 = (event) => {
  event.target.style.height = 'auto';
  event.target.style.height = `${event.target.scrollHeight}px`;
  
  // Check if modifyTest and its properties are defined
  if (modifyTest && modifyTest.response && modifyTest.response.answer) {
   
     // Create a deep copy of the answer array
     const answerCopy = JSON.parse(JSON.stringify(modifyTest.response.answer));

     // Create the updatedModifyTest object with the deep copy
     const updatedModifyTest = {
       ...modifyTest,
       response: {
         ...modifyTest.response,
         answer: answerCopy
       }
     }
     
    updatedModifyTest.response.answer[0][0] = event.target.value // Update the answer
    setModifyTest(updatedModifyTest);

  } else {
      console.error("modifyTest structure is not valid", modifyTest);
  }
};


const handleChangeAnswer2 = (event) => {
  event.target.style.height = 'auto';
  event.target.style.height = `${event.target.scrollHeight}px`;
 
   // Check if modifyTest and its properties are defined
   if (modifyTest && modifyTest.response && modifyTest.response.answer) {
      // Create a deep copy of the answer array
      const answerCopy = JSON.parse(JSON.stringify(modifyTest.response.answer));

      // Create the updatedModifyTest object with the deep copy
      const updatedModifyTest = {
        ...modifyTest,
        response: {
          ...modifyTest.response,
          answer: answerCopy
        }
      }
 
      updatedModifyTest.response.answer[1][0] = event.target.value // Update the answer
      setModifyTest(updatedModifyTest);
  
    } else {
        console.error("modifyTest structure is not valid", modifyTest);
    }
 
};

const handleChangeAnswer3 = (event) => {
  event.target.style.height = 'auto';
  event.target.style.height = `${event.target.scrollHeight}px`;

   // Check if modifyTest and its properties are defined
   if (modifyTest && modifyTest.response && modifyTest.response.answer) {
      // Create a deep copy of the answer array
      const answerCopy = JSON.parse(JSON.stringify(modifyTest.response.answer));

      // Create the updatedModifyTest object with the deep copy
      const updatedModifyTest = {
        ...modifyTest,
        response: {
          ...modifyTest.response,
          answer: answerCopy
        }
      }

      updatedModifyTest.response.answer[2][0] = event.target.value // Update the answer
      setModifyTest(updatedModifyTest);

    } else {
        console.error("modifyTest structure is not valid", modifyTest);
    }
};

const handleSave = async (e) => {
  if (  modifyTest.prompt.trim() === ""
        || modifyTest.response.answer[0][0].trim() === ""
        || modifyTest.response.answer[1][0].trim() === "" 
        || modifyTest.response.answer[2][0].trim() === "" )
    {
          setStatus(changeLanguage("aitest", "modifytestempty"))
          return
    }
    
    /*
    let updatedTests = [...promptsandresponses]
    updatedTests[modifyTest.id] = modifyTest
    setPromptsAndResponses(updatedTests)
    */
    let updatedTests = [...subtopics]
    console.log('Subtopics before:', updatedTests)
    updatedTests[modifyTest.subtopicindex].promptsandresponses[modifyTest.id] = modifyTest
    console.log('Subtopics after:', updatedTests)
    setSubtopics(updatedTests)

    handleClose()
}

const handleClose = () => {
  console.log("handleClose")
  setStatus('')
  //setShowCustomPromptDialog(false);
  setShowModifyTestDialog(false)
};

  return (
   
    <React.Fragment>
   
        <Dialog
          open={showModifyTestDialog}
          onClose={handleClose}
          PaperProps={{
            component: 'form',
            onSubmit: (event) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              const formJson = Object.fromEntries(formData.entries());
              const email = formJson.email;
              console.log(email);
              handleClose();
            },
          }}
        >

        <DialogTitle className="dialogTitleModifyTest">({modifyTest !== null && modifyTest.id+1}) {changeLanguage('aitest', 'dialogmodifytest')}</DialogTitle>

        <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
       <CloseIcon />
      </IconButton>
      <IconButton
          aria-label="close"
          onClick={handleSave}
          sx={{
            position: 'absolute',
            right: 42,
            top: 0,
            color: (theme) => theme.palette.grey[500],
          }}
        >
        <button className='updateButton'>{changeLanguage('common','dialogupdate')}</button>
        <br></br>
      </IconButton>
       
        <DialogContent dividers>
          <div >
            {
              createcollegetestmode && (
              <>
             <button type="button" className='updateButton' onClick={handleUpdateFormulaQuestion} >{changeLanguage('aitest','updateformulas')}</button>
             <button type="button" className='updateButton' onClick={handleTranslateQuestion} >{changeLanguage('aitest','translatetext')}</button>
              </>
              )
            }
              <label className='modifyTestLabel'>{changeLanguage('aitest', 'dialogquestion')}</label>
            
              {
                (modifyTest !== null) &&
                 <>
                <MarkdownResponseDisplay text={modifyTest.prompt} paragraphcolor={'maroon'}/>  
                <ScrollText rows={2} text={modifyTest.prompt} onChange={handleChangeQuestion} />  
                </>
              }

              <br></br>
           
              <div className = 'flex-container'>
                {
                   createcollegetestmode && (
                    <>
                  <button type="button" className='updateButton' onClick={handleUpdateFormulaAnswer1} >{changeLanguage('aitest','updateformulas')}</button>
                  <button type="button" className='updateButton' onClick={handleTranslateAnswer1} >{changeLanguage('aitest','translatetext')}</button>
                    </>
                )}
                 {
                (modifyTest !== null && modifyTest.response.answer[0][3] === true) ?
                  <CheckIcon />
                  :
                  <CancelIcon />
                }
                <label className='modifyTestLabel'>{changeLanguage('aitest', 'dialoganswer_1')}</label>
              </div>
              {
                (modifyTest !== null) &&
                <>
                <MarkdownResponseDisplay text={modifyTest.response.answer[0][0]} paragraphcolor={'maroon'}/>  
                <ScrollText rows={2}  text={modifyTest.response.answer[0][0]} onChange={handleChangeAnswer1}/> 
                </>
              }
            
              <br></br>
              <div className = 'flex-container'>
                {
                   createcollegetestmode && (
                    <>
                    <button type="button" className='updateButton' onClick={handleUpdateFormulaAnswer2} >{changeLanguage('aitest','updateformulas')}</button>
                    <button type="button" className='updateButton' onClick={handleTranslateAnswer2} >{changeLanguage('aitest','translatetext')}</button>
                    </>
                )}
                {
                (modifyTest !== null && modifyTest.response.answer[1][3] === true) ?
                  <CheckIcon />
                  :
                  <CancelIcon />
                }
                <label className='modifyTestLabel'>{changeLanguage('aitest', 'dialoganswer_2')}</label>
                
              </div>
              {
                (modifyTest !== null) &&
                <>
                  <MarkdownResponseDisplay text={modifyTest.response.answer[1][0]} paragraphcolor={'maroon'}/> 
                  <ScrollText rows={2}  text={modifyTest.response.answer[1][0]} onChange={handleChangeAnswer2}/>
                </>
              }
              <br></br>
              <div className = 'flex-container'>
                {
                   createcollegetestmode && (
                    <>
                      <button type="button" className='updateButton' onClick={handleUpdateFormulaAnswer3} >{changeLanguage('aitest',"updateformulas")}</button>
                      <button type="button" className='updateButton' onClick={handleTranslateAnswer3} >{changeLanguage('aitest','translatetext')}</button>
                    </>
                )}
                {
                  (modifyTest !== null && modifyTest.response.answer[2][3] === true) ?
                <CheckIcon />
                :
                <CancelIcon />
                }
                <label className='modifyTestLabel'>{changeLanguage('aitest', 'dialoganswer_3')}</label>
              </div>
              {
                (modifyTest !== null) &&
                <>
                 <MarkdownResponseDisplay text={modifyTest.response.answer[2][0]} paragraphcolor={'maroon'}/> 
                <ScrollText rows={2}  text={modifyTest.response.answer[2][0]} onChange={handleChangeAnswer3}/>
                </>
              }
            
              <br></br>
              {
                (status) && <label>{status}</label>
              }
          </div>
          
        </DialogContent>
      </Dialog>
    </React.Fragment>
    
  );
  
}